import { useNavigate } from 'react-router-dom'
import { Icon } from './Icon'

export function PageHeader({ title, backTo, onBack, right }) {
  const navigate = useNavigate()

  const handleBack = () => {
    if (onBack) onBack()
    else if (backTo) navigate(backTo)
    else navigate(-1)
  }

  return (
    <header className="page-header">
      {(backTo !== undefined || onBack) && (
        <button className="page-header__back" onClick={handleBack} aria-label="Назад">
          <Icon name="chevronLeft" size={20} />
        </button>
      )}
      <span className="page-header__title">{title}</span>
      {right && <div className="page-header__right">{right}</div>}
    </header>
  )
}
